// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
/* eslint-disable @typescript-eslint/no-unused-vars */
import { ApiResult, get, put, post } from "./api_client";
import { WeatherTypes, TimeOfDay, SceneType, TargetTypes, FHWAClasses } from "../models";
import { PhotoMetaSearchResult, IPhotoMetaSearchResult, PhotoMetaSummary, IPhotoMetaSummary, PhotoDownloadUrl, IPhotoDownloadUrl, PhotoMeta, IPhotoMeta, PhotoMetaBulkUpdateRequest, IPhotoMetaBulkUpdateRequest } from "../models";
/* eslint-enable @typescript-eslint/no-unused-vars */

export async function search(limit: number, sortKey?: string, sortDirection?: string, organizationId?: string, deviceId?: string, weather?: WeatherTypes, timeOfDay?: TimeOfDay, scene?: SceneType, targetTypesInView?: TargetTypes, fhwaClassesInView?: FHWAClasses, dewarpedImage?: boolean, needsReview?: boolean, numLanes?: number, dateFrom?: Date, dateTo?: Date, minWidth?: number, maxWidth?: number, minHeight?: number, maxHeight?: number, addedToTrainingDataset?: boolean, trainingDatasetName?: string, cursor?: string): ApiResult<PhotoMetaSearchResult> {
		const queryParams = [limit !== undefined ? `limit=${limit}` : undefined,
			sortKey !== undefined ? `sortKey=${sortKey}` : undefined,
			sortDirection !== undefined ? `sortDirection=${sortDirection}` : undefined,
			organizationId !== undefined ? `organizationId=${organizationId}` : undefined,
			deviceId !== undefined ? `deviceId=${deviceId}` : undefined,
			weather !== undefined ? `weather=${weather}` : undefined,
			timeOfDay !== undefined ? `timeOfDay=${timeOfDay}` : undefined,
			scene !== undefined ? `scene=${scene}` : undefined,
			targetTypesInView !== undefined ? `targetTypesInView=${targetTypesInView}` : undefined,
			fhwaClassesInView !== undefined ? `fhwaClassesInView=${fhwaClassesInView}` : undefined,
			dewarpedImage !== undefined ? `dewarpedImage=${dewarpedImage}` : undefined,
			needsReview !== undefined ? `needsReview=${needsReview}` : undefined,
			numLanes !== undefined ? `numLanes=${numLanes}` : undefined,
			dateFrom !== undefined ? `dateFrom=${dateFrom.toISOString()}` : undefined,
			dateTo !== undefined ? `dateTo=${dateTo.toISOString()}` : undefined,
			minWidth !== undefined ? `minWidth=${minWidth}` : undefined,
			maxWidth !== undefined ? `maxWidth=${maxWidth}` : undefined,
			minHeight !== undefined ? `minHeight=${minHeight}` : undefined,
			maxHeight !== undefined ? `maxHeight=${maxHeight}` : undefined,
			addedToTrainingDataset !== undefined ? `addedToTrainingDataset=${addedToTrainingDataset}` : undefined,
			trainingDatasetName !== undefined ? `trainingDatasetName=${trainingDatasetName}` : undefined,
			cursor !== undefined ? `cursor=${cursor}` : undefined]
		var query = queryParams.filter((v) => (v !== undefined)).join('&');
		if (query && query.length)
			query = '?' + query;

	return get<IPhotoMetaSearchResult>(`/api/photometa/search${query}`).then(result => result === undefined ? undefined :  new PhotoMetaSearchResult(result));
}

export async function getById(id?: string): ApiResult<PhotoMetaSummary> {
	return get<IPhotoMetaSummary>(`/api/photometa/${ id }`).then(result => result === undefined ? undefined :  new PhotoMetaSummary(result));
}

export async function update(id?: string, update?: PhotoMeta): ApiResult<PhotoMetaSummary> {
	return put<IPhotoMetaSummary>(`/api/photometa/${ id }`, update).then(result => result === undefined ? undefined :  new PhotoMetaSummary(result));
}

export async function bulkUpdate(request: PhotoMetaBulkUpdateRequest): ApiResult<number> {
	return put<number>(`/api/photometa/bulk-update`, request);
}

export async function bulkDelete(ids?: string[]): ApiResult<number> {
	return post<number>(`/api/photometa/bulk-delete`, ids);
}

export async function getDownloadUrls(ids?: string[]): ApiResult<PhotoDownloadUrl[]> {
	return post<IPhotoDownloadUrl[]>(`/api/photometa/download-urls`, ids).then(result => result === undefined ? undefined : result.map(o => new PhotoDownloadUrl(o)));
}

export async function downloadZip(ids?: string[]): ApiResult<undefined> {
	return post(`/api/photometa/download-zip`, ids);
}
